"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCreativeCorner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const projects = [{
    name: "Classroom Mural Project",
    tag: "ART · PAINTING",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_mural_art.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_mural_art.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/classroom_mural_art.png-wvc-sizes",
    height: "h-[420px]"
  }, {
    name: "Cozy Reading Nook",
    tag: "LEARNING · COMFORT",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/reading_nook_space.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/reading_nook_space.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/reading_nook_space.png-wvc-sizes",
    height: "h-[320px]"
  }, {
    name: "Science Fair Models",
    tag: "STEM · DISCOVERY",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/science_fair_models.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/science_fair_models.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/science_fair_models.png-wvc-sizes",
    height: "h-[360px]"
  }, {
    name: "Student Art Gallery",
    tag: "CREATIVITY · DISPLAY",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/student_art_wall.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/student_art_wall.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/student_art_wall.png-wvc-sizes",
    height: "h-[460px]"
  }, {
    name: "Math Manipulatives",
    tag: "LEARNING · TOOLS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/math_learning_tools.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/math_learning_tools.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/math_learning_tools.webp-wvc-sizes",
    height: "h-[300px]"
  }, {
    name: "Group Project Table",
    tag: "COLLABORATION · WORK",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/group_project_table.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/group_project_table.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/group_project_table.png-wvc-sizes",
    height: "h-[380px]"
  }, {
    name: "Nature Study Corner",
    tag: "SCIENCE · EXPLORATION",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/nature_study_corner.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/nature_study_corner.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/nature_study_corner.png-wvc-sizes",
    height: "h-[340px]"
  }, {
    name: "Writing Workshop Desk",
    tag: "LITERACY · WRITING",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/writing_workshop_desk.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/writing_workshop_desk.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/writing_workshop_desk.webp-wvc-sizes",
    height: "h-[400px]"
  }, {
    name: "Building Block Station",
    tag: "ENGINEERING · PLAY",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/building_block_station.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/building_block_station.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700640/img/building_block_station.png-wvc-sizes",
    height: "h-[320px]"
  }];
  return <section data-section-id="2251" id="the-creative-corner" className="bg-background py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <div ref={ref} className={`mb-12 md:mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex-1">
            <p className="font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground mb-5">
              Classroom Highlights
            </p>
            <h2 className="font-default font-semibold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              Creative moments in Class 2A.
            </h2>
          </div>
          <div className="md:pb-3">
            <Link to="/OurJourneyPage" className="inline-flex items-center gap-2 text-sm text-foreground border-b border-foreground/30 pb-1 hover:border-foreground transition-colors group">
              <span>See All Projects</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {projects.map((project, i) => <div data-index={i} key={i} className="mb-5 break-inside-avoid group relative overflow-hidden rounded-lg border border-border bg-card shadow-md">
              <div className={`relative ${project.height} overflow-hidden`}>
                <img src={project.src} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />

                {}
                <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  <div className="bg-secondary/95 backdrop-blur-sm px-6 py-5">
                    <h3 className="font-default font-semibold text-xl text-secondary-foreground leading-tight mb-1.5">
                      {project.name}
                    </h3>
                    <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-secondary-foreground/70">
                      {project.tag}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}